module.exports = __webpack_public_path__ + "img/home_image_jinriprixun@2x.a05d535c.png";